import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { CartShippingModel } from '@/models';
import { useAppDispatch, useAppSelector } from '@/redux';
import { UntypedObject } from '@/types';
import { updateCartAttributeByName } from '@/redux/thunks/checkout/updateCartAttributeByName';

import MillesimaPrice from '@/components/common/price/MillesimaPrice';
import CheckboxV2 from '@/components/common/CheckboxV2';

import styles from './WeatherHold.module.scss';
import { PRICE } from '@/constants/price';

type WoodenCaseProps = {
  woodenCase: UntypedObject;
  deliveryMode: CartShippingModel;
  isExproCheckout: boolean;
  isSelected: boolean;
}

export const WoodenCase = ({ woodenCase, deliveryMode, isExproCheckout = false, isSelected = false }: WoodenCaseProps) => {
  const dispatch = useAppDispatch();
  const userHasChosenWoodenCase = useAppSelector(({ cart }) => cart.content.shippingMode?.userHasChosenWoodenCase);
  const { t } = useTranslation();

  const [withWoodenCase, setWithWoodenCase] = useState(userHasChosenWoodenCase);
  const { description, price, title } = woodenCase;

  const handleClick = (withWoodenCase: boolean) => {
    setWithWoodenCase(withWoodenCase);
    const updateDeliveryMode = {
      ...deliveryMode,
      userHasChosenWoodenCase: withWoodenCase
    };
    dispatch(updateCartAttributeByName({ attributeName: 'shippingMode', newValue: updateDeliveryMode }));
  };

  const className = [
    styles.container,
    !withWoodenCase && styles.unchecked,
  ].filter(Boolean).join(' ');

  return isExproCheckout === false && (
    <div className={className} data-test-id="container">
      <div className={styles.recommend} data-test-id="recommend">{t('checkout:shipMode.deliveryOption')}</div>
      <div className={styles.header} data-test-id="header">
        <CheckboxV2 onChange={() => handleClick(!withWoodenCase)} checked={withWoodenCase} />
        <div className={styles['header-information']} data-test-id="header-information">
          <div className={styles.title} data-test-id="title" onClick={() => handleClick(!withWoodenCase)}>
            {title}
          </div>
          <MillesimaPrice
            value={price === 0 ? PRICE.FREE : +price}
            className={{ container: `${styles.price} ${price === 0 ? styles.free : ''}` }}
          />
        </div>
      </div>
      <p className={styles.description} data-test-id="description">
        {description}
      </p>
    </div>
  );
};

export default WoodenCase;
